export default {

	getFields(Selector) {
		let parameter: any;
		if(typeof Selector.WANT_INVOICE !== 'undefined'){
			parameter = Selector.WANT_INVOICE.is(':checked');
		} else {
			parameter = false;
		}

		return {
			'invoice[nip]': {
				required: parameter,
				nip: true,
				checkNipAndCompany : "#invoice_company_name",
				checkNipHasChanged : true
			},
			'invoice[company_name]': {required: parameter},
			'invoice[street]': {required: parameter},
			'invoice[hnumber]': {required: parameter},
			'invoice[postal]': {required: parameter, postalPL: true},
			'invoice[city]': {required: parameter},
			'invoice[phone]': {required: parameter, phonePL: true},
			'invoice[email]': {required: parameter, email: true},
			'invoice[change_content]': {required: parameter},
		};
	}
}export default {

	getFields(Selector) {
		let parameter: any;
		if(typeof Selector.WANT_INVOICE !== 'undefined'){
			parameter = Selector.WANT_INVOICE.is(':checked');
		} else {
			parameter = false;
		}

		return {
			'invoice[nip]': {
				required: parameter,
				nip: true,
				checkNipAndCompany : "#invoice_company_name",
				checkNipHasChanged : true
			},
			'invoice[company_name]': {required: parameter},
			'invoice[street]': {required: parameter},
			'invoice[hnumber]': {required: parameter},
			'invoice[postal]': {required: parameter, postalPL: true},
			'invoice[city]': {required: parameter},
			'invoice[phone]': {required: parameter, phonePL: true},
			'invoice[email]': {required: parameter, email: true},
			'invoice[change_content]': {required: parameter},
		};
	}
}